import { Layout, Select } from 'antd';
import { CaretLeftOutlined } from '@ant-design/icons';
import axios from 'axios';
import React from 'react';
import { Helmet } from 'react-helmet';
import ExternalPortalLanguage from '../../components/ExternalPortalLanguage';
import { TranslateContext } from '../../contexts/TranslationContext';
import ReturnPortalRouter from '../../routes/ReturnPortal';
import { IntercomControlContext } from '../../contexts/IntercomContext';
//styles
import '../../styles/Visitor.css';

// i18n
// import { FormattedMessage } from 'react-intl';
import { IconTray } from '../../components/CustomReturnsIcons';
import { getLocale } from '../../helpers/localePortal';
import { shopminisDeepLink } from '../../constants/constants';
import { FormattedMessage } from 'react-intl';

const { Header, Content } = Layout;
class ReturnPortal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      orderData: {},
      productData: {},
      returnSettings: {},
      brandName: undefined,
      storeUrl: undefined,
      storeShopifyUrl: undefined,
      faviconUrl: undefined,
      logoUrl: undefined,
      backgroundImageUrl: undefined,
      brandColor: undefined,
      brandColorButton: '#FFFFFF',
      brandColorButtonText: undefined,
      brandColorText: undefined,
      contactEmail: undefined,
      companyIdentifier: undefined,
      orderEmail: undefined,
      orderNumber: undefined,
      orderId: undefined,
      removeBackToStoreHeader: true,
      loadingSettings: true,
      brandFontStyle: undefined,
      brandFontSize: undefined,
      brandIncentivesColor: undefined,
      language: null,
      enableTranslation: false,
      enabledTranslations: [],
      fromShopminis: false,
    };
  }
  static contextType = IntercomControlContext;

  componentDidMount() {
    this.setState({ ...this.props });
  }

  componentDidUpdate(prevProps, prevState) {
    const updatedState = {};
    Object.keys(this.props).forEach((key) => {
      if (this.props[key] !== prevProps[key]) {
        updatedState[key] = this.props[key];
      }
    });

    if (Object.keys(updatedState).length > 0) {
      this.setState(updatedState);
    }
  }

  updateBrandSettings(settingsObject) {
    this.setState({
      ...settingsObject,
    });
  }

  handleCloseLoader = () => {
    this.setState({
      loadingSettings: false,
    });
  };

  handleLanguageChange = (language) => {
    this.setState({
      language,
    });
  };

  setEnableTranslation = (enable) => {
    this.setState({
      enableTranslation: enable,
    });
  };

  getStoreUrl = () => {
    const url =
      this.state.fromShopminis && this.state.orderId
        ? shopminisDeepLink + this.state.orderId
        : this.state.storeUrl;
    return url;
  };

  render() {
    const children = [];
    const enableTranslation = this.state.enableTranslation;
    const listTranslationCode =
      this.state.enabledTranslations?.map(
        (translation) => translation.languageCode
      ) || [];
    const defaultLanguage = getLocale(listTranslationCode);
    for (let i = 0; i < this.state.enabledTranslations?.length; i++) {
      children.push(
        <Select.Option key={this.state.enabledTranslations[i].languageCode}>
          {this.state.enabledTranslations[i].languageCode.toUpperCase()}
        </Select.Option>
      );
    }

    const languageDropdown = (
      <Select
        placeholder="Language"
        style={{
          width: '100px',
          position: 'fixed',
          top: '10px',
          right: '10px',
          zIndex: 1000,
        }}
        onChange={this.handleLanguageChange}
        defaultValue={defaultLanguage}
        notFoundContent={
          <div className="flex-row flex-middle-xxs flex-center-xxs">
            <div className="flex-col-xxs-12">
              <IconTray size="md" />
            </div>
            <div>
              <p className="TextBody TextBody--xxxs">No Data</p>
            </div>
          </div>
        }
      >
        {children}
      </Select>
    );

    return (
      <TranslateContext.Provider
        value={{
          enableTranslation: this.state.enableTranslation,
          setEnableTranslation: this.setEnableTranslation,
        }}
      >
        <ExternalPortalLanguage
          brandName={this.state.brandName}
          handleCloseLoader={this.handleCloseLoader}
          language={this.state.language}
          transla
        >
          <Helmet>
            <link rel="icon" href={this.state.faviconUrl} />
          </Helmet>
          <Layout
            style={
              this.state.backgroundImageUrl
                ? {
                    backgroundImage: `url(${this.state.backgroundImageUrl})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                  }
                : { background: this.state.brandColor }
            }
            className="PageLayout PageLayout--portal flex-center-xxs portalPageAlignment"
          >
            {this.state.removeBackToStoreHeader ? (
              <Header
                style={{
                  justifyContent: 'flex-end',
                  background: 'unset',
                  boxShadow: 'unset',
                }}
              >
                {enableTranslation &&
                  Boolean(this.state.enabledTranslations.length > 0) && (
                    <span>{languageDropdown}</span>
                  )}
              </Header>
            ) : (
              <Header>
                <span>
                  {this.state.loadingSettings ? (
                    <div className="GlobalLoader GlobalLoader--xs"></div>
                  ) : this.state.brandName ? (
                    <a
                      className="blackLink"
                      href={this.getStoreUrl()}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <CaretLeftOutlined className="u-marginRight--xs" />
                      <FormattedMessage
                        id="app.visitor.returnToStore"
                        description="Return to store"
                        defaultMessage={`Return to ${this.state.brandName}`}
                        values={{}}
                      />
                    </a>
                  ) : (
                    <a
                      className="blackLink"
                      href={this.getStoreUrl()}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <CaretLeftOutlined className="u-marginRight--xs" />
                      <FormattedMessage
                        id="app.visitor.returnToStore"
                        description="Return to store"
                        defaultMessage="Return to store"
                        values={{}}
                      />
                    </a>
                  )}
                </span>
                {enableTranslation &&
                  Boolean(this.state.enabledTranslations.length > 0) && (
                    <span>{languageDropdown}</span>
                  )}
              </Header>
            )}
            <Content id="mainContentElement">
              <ReturnPortalRouter
                updateBrandSettings={this.updateBrandSettings.bind(this)}
                {...this.state}
              />
            </Content>
          </Layout>
        </ExternalPortalLanguage>
      </TranslateContext.Provider>
    );
  }
}

export default ReturnPortal;
